import React from 'react';
import PropTypes from 'prop-types';
import { COLLECTION_DISPLAY_TYPES } from 'utils/constants';
import { useI18n } from 'components/I18n';
import {
  Box,
  Text,
  Spacer,
} from 'components';
import GridIcon from './GridIcon';
import ListIcon from './ListIcon';

export default function CollectionDisplayTypeSwitch({ selected, onClick }) {
  const i18n = useI18n();

  return (
    <Box flexBox alignItems="center">
      <Text
        id="search.modesView"
        color="secondary"
        noselect
      />

      <Spacer width="medium" />

      <button
        type="button"
        onClick={() => onClick(COLLECTION_DISPLAY_TYPES.grid)}
        aria-pressed={selected === COLLECTION_DISPLAY_TYPES.grid}
        aria-label={i18n.formatText('search.modesView') + ' ' + i18n.formatText('aria.search.grid')}
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
      >
        <GridIcon
          size="2.4375rem"
          selected={selected === COLLECTION_DISPLAY_TYPES.grid}
          role="presentation"
          tabIndex="-1"
        />
      </button>

      <Spacer width="small" />

      <button
        type="button"
        onClick={() => onClick(COLLECTION_DISPLAY_TYPES.list)}
        aria-pressed={selected === COLLECTION_DISPLAY_TYPES.list}
        aria-label={i18n.formatText('search.modesView') + ' ' + i18n.formatText('aria.search.list')}
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
      >
        <ListIcon
          size="2.4375rem"
          selected={selected === COLLECTION_DISPLAY_TYPES.list}
          role="presentation"
          tabIndex="-1"
        />
      </button>
    </Box>
  );
}

CollectionDisplayTypeSwitch.propTypes = {
  selected: PropTypes.oneOf(Object.values(COLLECTION_DISPLAY_TYPES)).isRequired,
  onClick: PropTypes.func.isRequired,
};
